import { setPreferredMFA as setPreferredMFAService, verifyTotpToken } from '../../../services';

import AuthActions from '/b2b/authentication/state/Auth.actions';

export const setPreferredMFA = params => dispatch => {
    dispatch(AuthActions.setPreferredMfaBegin(params));

    return setPreferredMFAService(params)
        .then(response => {
            return dispatch(AuthActions.setPreferredMfaSuccess(params, response));
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthActions.setPreferredMfaFailure(params, message));

            throw message;
        });
};

export const verify = params => dispatch => {
    return verifyTotpToken(params).then(() => {
        return setPreferredMFA({ mfaType: 'TOTP' })(dispatch);
    });
};
